export enum LanguageEnumeration {
	de = 'german',
	en = 'english',
	fr = 'french',
	it = 'italian',
}
